﻿export type ResultatValg = ResultatValgVisning;

export interface ResultatValgVisning {
    visSteg2: boolean;
    visSteg3: boolean;
    visSteg4a: boolean;
    visSteg4b: boolean;
    visSteg5: boolean;
    visGenerellFeil: boolean;
}

export const SET_VISNING = 'SET_VISNING';

export interface SetVisningAction {
    type: typeof SET_VISNING;
    payload: Partial<ResultatValgVisning>;
}

export type ResultatActionTypes = SetVisningAction;
